<template>
  <div class="sidebar-wrapper d-flex justify-content-between flex-column flex-grow-1">
    <div class="p-2">
      <!-- <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        aria-controls="sidebar-add-new-event"
        :aria-expanded="String(isEventHandlerSidebarActive)"
        variant="primary"
        block
        @click="$emit('update:isEventHandlerSidebarActive', true)"
      >
        Add Event
      </b-button> -->
      <div v-if="user.role === 'admin' || appConfig.type === 'ow-admin'" class="mt-3">
        <h5 class="app-label section-label mb-1">
          <span class="align-middle">{{ $t('choose_area') }}</span>
        </h5>
        <vue-autosuggest
          :suggestions="filteredOptions"
          :limit="10"
          :input-props="{
            id: 'autosuggest__input',
            class: 'form-control',
            placeholder: $t('gig_page.location_placeholder'),
            style: 'text-transform: capitalize',
          }"
          @input="onInputChange"
          @selected="onSelected"
        >
          <template slot-scope="{ suggestion }">
            <span
              class="my-suggestion-item"
              style="text-transform: capitalize"
            >
              {{ suggestion.item.name }}
            </span>
          </template>
        </vue-autosuggest>
      </div>
      <div class="mt-3">
        <h5 class="app-label section-label mb-1">
          <span class="align-middle">{{ $t('shifts_calendar.calendars') }}</span>
        </h5>
        <b-form-checkbox
          v-model="checkAll"
          class="mb-1"
        >
          {{ $t('shifts_calendar.view_all') }}
        </b-form-checkbox>
        <b-form-group>
          <b-form-checkbox-group
            v-model="selectedCalendars"
            name="event-filter"
            stacked
          >
            <b-form-checkbox
              v-for="item in calendarOptions"
              :key="item.value"
              name="event-filter"
              :value="item.value"
              class="mb-1"
              :class="`custom-control-${item.color}`"
            >
              {{ item.label }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </div>
    </div>
    <b-img :src="require('@hw-ui/assets/images/pages/calendar-illustration.png')" />
  </div>
</template>

<script>
import {
  BFormGroup, BFormCheckboxGroup, BFormCheckbox, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { VueAutosuggest } from 'vue-autosuggest'
import useCalendarSidebar from './useCalendarSidebar'

export default {
  directives: {
    Ripple,
  },
  components: {
    BImg,
    BFormCheckbox,
    BFormGroup,
    BFormCheckboxGroup,
    VueAutosuggest,
  },
  props: {
    isEventHandlerSidebarActive: {
      type: Boolean,
      require: true,
    },
    areaId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      filteredOptions: [],
    }
  },
  computed: {
    user() {
      return this.$store.state.appAuth.authUser ? this.$store.state.appAuth.authUser : {}
    },
    appConfig() {
      return this.$store.state.app.appConfig || {}
    },
  },
  methods: {
    onInputChange(text) {
      if (text === '' || text === undefined) {
        this.$emit('update:areaId', null)
        return
      }
      this.$emit('search-location', {
        text: text.toLowerCase(),
        callback: result => {
          this.filteredOptions = [{ data: result }]
        },
      })
    },
    onSelected(option) {
      if (option) {
        this.$emit('update:areaId', option.item.id)
      }
    },
  },
  setup() {
    const {
      calendarOptions,
      selectedCalendars,
      checkAll,
    } = useCalendarSidebar()
    return {
      calendarOptions,
      selectedCalendars,
      checkAll,
    }
  },
}
</script>

<style>

</style>
